import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react'
import TextLink from 'components/Luxkit/TextLink'

export interface CounterRef {
  startCountdown: () => void;
}

interface Props {
  initialCount?: number;
  onClick: () => void;
}

const AccountAccessLoginOTPCountdown = forwardRef<CounterRef, Props>((props, ref) => {
  const { initialCount = 30, onClick } = props
  const [count, setCount] = useState<number>(initialCount)
  const intervalRef = useRef<NodeJS.Timeout>()

  const clear = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
    }
  }, [])

  const startCountdown = useCallback(() => {
    clear()
    setCount(initialCount)

    intervalRef.current = setInterval(() => {
      setCount((curr) => curr - 1)
    }, 1000)
  }, [clear, initialCount])

  // Stops the countdown when it reaches zero
  useEffect(() => {
    if (count <= 0) {
      clear()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count])

  // Start counter automatically
  useEffect(() => {
    startCountdown()

    return () => {
      clear()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useImperativeHandle(ref, () => ({ startCountdown, clear }))

  return (
    <TextLink size="medium" onClick={onClick} disabled={count > 0}>
      {count > 0 ? `Resend code in ${count}s` : 'Resend code'}
    </TextLink>
  )
})

export default AccountAccessLoginOTPCountdown
